/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars-2';
import {
  Modal,
  Label,
  Loader,
  Portal,
  Ref,
} from 'semantic-ui-react';
import Update from 'immutability-helper';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import combineImg from '../../images/components/my/combined-shape-2.svg';
import BookmarkItem from './BookmarkItem';
import BookmarkItemType2 from './BookmarkItemType2';
import NavigationBar from './NavigationBar';
import WithRouter from '../Extensions/WithRouter';

class MyBookmark extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.bookmarkListScroll = React.createRef();
    this.state = {
      pageSize: 20,
      currentCount: '',
      isOpenModal: false,
      isBookmarkLoading: false,
      isRecentLoading: false,
      isPageLoading: false,
      errSearch: false,
      isOpenError: false,
      deletedId: '',
      bookmarkDataList: [],
      recentList: [],
      selectedRecentList: [],
      searchKeyword: '',
      selectedIndex: [],
      uploadedDataList: [],
      projectDataList: [],
      activeIndex: [],
      activeTab: 'files',
      descriptionWithModal: '',
      isDeleteBookmark: false,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.deleteMyRecent = this.deleteMyRecent.bind(this);
    this.deleteMyBookmark = this.deleteMyBookmark.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleTableToggle = this.handleTableToggle.bind(this);
    this.handleAddtoBookmark = this.handleAddtoBookmark.bind(this);
    this.handleViewPointChange = this.handleViewPointChange.bind(this);
    this.handleRemoveBookmark = this.handleRemoveBookmark.bind(this);
    this.handleRemoveRecentList = this.handleRemoveRecentList.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.updateTreeIndex = this.updateTreeIndex.bind(this);
    this.getMyBookmarkData = this.getMyBookmarkData.bind(this);
    this.createMyBookmark = this.createMyBookmark.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();

    $(document).on(
      'mouseover',
      '.modal_popup_wrap .modal_popup_box .modal_popup .small_text',
      function () {
        const $this = $(this);
        if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
          $this.attr('title', $this.text());
        }
      }
    );
    $(document).on('mouseover', '.my_bookmarks_item_table td .info .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getMyBookmarkData();
      this.getRecentData();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  componentWillUnmount() {}

  handleScroll = (event) => {
    const {
      getMyBookmarkData,
      state: {
        error, isBookmarkLoading, hasMore, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isBookmarkLoading || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      getMyBookmarkData(currentPage + 1);
    }
  };

  handleTableToggle = (id) => {
    const { selectedRecentList } = this.state;
    let newState;

    if (selectedRecentList.indexOf(id) > -1) {
      newState = selectedRecentList.filter((item) => {
        return item !== id;
      });
    } else {
      newState = [...selectedRecentList, id];
    }
    this.setState({
      selectedRecentList: newState,
    });
  };

  handleAddtoBookmark() {
    const { selectedRecentList, recentList } = this.state;

    const selectedData = recentList.filter((item) => {
      return selectedRecentList.indexOf(item.id) > -1;
    });

    const newData = selectedData.map((item) => {
      return {
        uploaded_file_id: item.target_id.uploaded_file_id,
        view_point: item.view_point,
      };
    });

    const newObj = {
      selected: newData,
    };

    this.createMyBookmark(newObj);
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return false;
      }

      this.setState(
        {
          searchKeyword: event.target.value,
          bookmarkDataList: [],
        },
        () => {
          this.getMyBookmarkData();
        }
      );
    }
  }

  handleTabChange(activeTab) {
    if (activeTab === 'files') {
      this.setState({
        activeTab,
      });
    } else {
      this.setState({
        activeTab,
        uploadedDataList: [],
      });
    }
  }

  handleViewPointChange = (id, newValue) => {
    const { bookmarkDataList } = this.state;
    const obj = {
      view_point: newValue,
    };
    const updatedIndex = bookmarkDataList.findIndex((item) => {
      return item.id === id;
    });

    api
      .updateBookmarkView(obj, id)
      .then(() => {
        this.setState({
          bookmarkDataList: Update(bookmarkDataList, {
            [updatedIndex]: {
              viewPoint: {
                $set: newValue,
              },
            },
          }),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleRemoveBookmark = (obj) => {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('my_page.my_issue.message.delete_bookmark');
    this.setState({
      deletedId: obj.id,
      descriptionWithModal: obj.name,
      isOpenModal: true,
      isDeleteBookmark: true,
    });
  };

  handleRemoveRecentList = (obj) => {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('my_page.my_issue.message.delete_recent_record');
    this.setState({
      deletedId: obj.id,
      descriptionWithModal: obj.name,
      isOpenModal: true,
      isDeleteBookmark: false,
    });
  };

  handleChangeView = (obj) => {
    const { navigate, state } = this.props;
    const basePath = `/results/${obj.viewPoint}`;
    let url = '';
    let navigateOptions = {};
    let targetProjectName = '';
    let targetProjectVersionName = '';
    let targetFileName = '';

    if (obj.targetObject === 'project') {
      targetProjectName = obj.name;
    } else if (obj.targetObject === 'project_version') {
      targetProjectName = obj.projectName;
      targetProjectVersionName = obj.name;
    } else if (obj.targetObject === 'report') {
      targetProjectName = obj.projectName;
      targetFileName = obj.name;
    }

    if (obj.targetObject === 'report') {
      const pathSuffix = obj.viewPoint === 'policy' ? 'project' : 'binary';
      url = `${basePath}/${pathSuffix}/${obj.targetId.uploaded_file_id}`;

      state.report.setNavBookmark(
        obj.targetId,
        targetProjectName,
        targetProjectVersionName,
        targetFileName
      );
    } else if (
      obj.targetObject === 'project_version'
      || obj.targetObject === 'project'
    ) {
      state.report.setNavBookmark(
        obj.targetId,
        targetProjectName,
        targetProjectVersionName,
        targetFileName
      );

      url = `${basePath}/project`;

      navigateOptions = {
        state: {
          fromList: true,
          prev: 'result',
          currentPage: 1,
          params: obj.targetId,
        },
      };
    }

    if (obj.type === 'current') {
      if (Object.keys(navigateOptions).length) {
        navigate(url, navigateOptions);
      } else {
        navigate(url);
      }
    } else if (obj.type === 'window') {
      localStorage.setItem('bookmarkObj', JSON.stringify(obj));
      const baseUrl = window.location.href.split('#')[0];
      let finalUrl = `${baseUrl}#${url}`;

      if (navigateOptions.state && navigateOptions.state.params) {
        const { params } = navigateOptions.state;
        const searchParams = new URLSearchParams();

        if (params.project_id) {
          searchParams.set('project', params.project_id);
        }
        if (params.project_version_id) {
          searchParams.set('project_version', params.project_version_id);
        }
        if (params.uploaded_file_id) {
          searchParams.set('uploaded_file', params.uploaded_file_id);
        }

        const queryStr = searchParams.toString();

        if (queryStr) {
          const separator = finalUrl.includes('?') ? '&' : '?';
          finalUrl = `${finalUrl}${separator}${queryStr}`;
        }
      }

      window.open(finalUrl, '_blank');
    }
  };

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onDragEnd(result) {
    const { t } = this.props;
    const {
      selectedIndex,
      bookmarkDataList,
    } = this.state;
    const {
      source,
      destination,
      draggableId,
    } = result;
    this.modalAction = t('modal.title.attention');

    if (selectedIndex.length > 1) {
      this.modalBody = t('my_page.my_issue.message.drag_drop_object');

      return this.setState({ isOpenError: true });
    }

    if (!destination
      || (source.droppableId === destination.droppableId
      && (source.droppableId === 'all-project' || source.droppableId === 'all-files'))) {
      this.modalBody = t('my_page.my_issue.message.drag_drop_to_bookmark');
      return this.setState({ isOpenError: true });
    }

    if (source.droppableId.startsWith('project_version') && (destination.droppableId === 'all-project' || destination.droppableId.startsWith('project_version'))) {
      this.modalBody = t('my_page.my_issue.message.drag_drop_to_bookmark');
      return this.setState({ isOpenError: true });
    }

    if (source.droppableId === destination.droppableId) {
      const items = this.reorder(bookmarkDataList, source.index, destination.index);
      this.setState({ bookmarkDataList: items });
    } else {
      this.move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination,
        draggableId
      );
    }
  }

  getList = (id) => {
    const { projectDataList, bookmarkDataList, uploadedDataList } = this.state;

    const listMap = {
      'all-bookmarks': bookmarkDataList,
      'all-files': uploadedDataList,
      'all-project': projectDataList,
    };

    if (id.startsWith('project_version-')) {
      const projectId = id.split('-')[1];
      const project = projectDataList.find((p) => { return p.data.id.toString() === projectId; });
      return project ? project.children : [];
    }
    return listMap[id] || [];
  };

  getLeftData = (array, type) => {
    if (type === 'files') {
      this.setState({
        uploadedDataList: array,
        projectDataList: [],
      });
    } else {
      this.setState({
        uploadedDataList: [],
        projectDataList: array,
      });
    }
  };

  getMyBookmarkData(pageNo, limit) {
    const { pageSize, searchKeyword } = this.state;
    const page = pageNo || 1;
    const perPage = limit || pageSize;
    const obj = {
      page,
      limit: perPage,
      search: searchKeyword,
    };

    if (page === 1) {
      this.setState({
        isBookmarkLoading: true,
      }, () => {
        this.fetchBookmarkData(obj);
      });
    } else {
      this.fetchBookmarkData(obj);
    }
  }

  async getRecentData() {
    this.setState({
      isRecentLoading: true,
    });

    await api
      .getRecentData()
      .then((response) => {
        const data = response.response;
        this.setState({
          recentList: data,
          isRecentLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isRecentLoading: false,
        });
      });
  }

  handleToggle = (newState) => {
    this.setState({
      selectedIndex: newState,
    });
  };

  updateTreeIndex = (newArray) => {
    this.setState({
      activeIndex: newArray,
    });
  };

  fetchBookmarkData = async (obj) => {
    const { bookmarkDataList } = this.state;
    await api
      .getMyBookmarkData(obj)
      .then((response) => {
        if (bookmarkDataList.length !== 0 && response.pagination.current === 1) {
          return null;
        }
        const nextBookmarkDataList = response.response.map((item) => {
          return {
            id: item.id,
            name: item.name,
            targetObject: item.target_object,
            targetId: item.target_id,
            viewPoint: item.view_point,
            extraData: item.extra_data,
            isOverviewAllowed: item.is_overview_allowed,
            isComponentAllowed: item.is_component_allowed,
            isSecurityAllowed: item.is_security_allowed,
            isLicenseAllowed: item.is_license_allowed,
            isPolicyAllowed: item.is_policy_allowed,
          };
        });

        const bookmarkId = bookmarkDataList.map((item) => {
          return item.id;
        });

        const newData = nextBookmarkDataList.filter((item) => {
          return bookmarkId.indexOf(item.id) === -1;
        });

        this.setState({
          currentPage: response.pagination.current,
          pageSize: response.pagination.per_page,
          currentCount: response.pagination.count,
          hasMore: response.pagination.next !== null,
          isBookmarkLoading: false,
          bookmarkDataList: [...bookmarkDataList, ...newData],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isBookmarkLoading: false,
        });
      });
  };

  reorder = (list, startIndex, endIndex) => {
    const { bookmarkDataList } = this.state;
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    const obj = {
      src_id: bookmarkDataList[startIndex].id,
      dest_id: bookmarkDataList[endIndex].id,
      dest_pos: startIndex > endIndex ? 'above' : 'below',
    };

    api
      .reorderMyBookmark(obj)
      .then()
      .catch((err) => {
        console.log(err);
      });
    return result;
  };

  move = (source, destination, droppableSource, droppableDestination, draggableId) => {
    const { activeTab, projectDataList } = this.state;
    const newObj = {};

    if (activeTab === 'files') {
      newObj.selected = [{
        uploaded_file_id: source[droppableSource.index].id,
        view_point: source[droppableSource.index].viewPoint,
      }];
    } else if (droppableSource.droppableId.startsWith('project_version')) {
      const projectId = Number(droppableSource.droppableId.split('-')[1]);
      const projectIndex = projectDataList.findIndex((p) => { return p.data.id === projectId; });
      const versionIndex = Number(droppableSource.index);
      const projectVersionId = projectDataList[projectIndex].children[versionIndex].data.id;
      newObj.selected = [{
        project_version_id: projectVersionId,
        view_point: projectDataList[projectIndex].children[versionIndex].data.view_point,
      }];
    } else if (droppableSource.droppableId === 'all-project') {
      const projectId = source[droppableSource.index].data.id;
      newObj.selected = [{
        project_id: projectId,
        view_point: source[droppableSource.index].data.view_point,
      }];
    } else if (droppableSource.droppableId.startsWith('report')) {
      const projectId = Number(droppableSource.droppableId.split('-')[1]);
      const projectIndex = projectDataList.findIndex((p) => { return p.data.id === projectId; });
      const projectVersionId = Number(draggableId.split('-')[1]);
      const projectVersionIndex = projectDataList[projectIndex].children.findIndex((p) => { return p.data.id === projectVersionId; });
      const reportId = Number(draggableId.split('-')[2]);
      const reportIndex = projectDataList[projectIndex].children[projectVersionIndex].children.findIndex((r) => { return r.data.id === reportId; });
      newObj.selected = [{
        report_id: reportId,
        view_point: projectDataList[projectIndex].children[projectVersionIndex].children[reportIndex].data.view_point,
      }];
    }
    this.createMyBookmark(newObj, droppableDestination.index);
  };

  createMyBookmark = async (selectedData, destinationIndex) => {
    try {
      const { response } = await api.createMyBookmark(selectedData);

      const newData = response.map((item) => {
        return {
          id: item.id,
          name: item.name,
          targetObject: item.target_object,
          targetId: item.target_id,
          viewPoint: item.view_point,
          extraData: item.extra_data,
          isOverviewAllowed: item.is_overview_allowed,
          isComponentAllowed: item.is_component_allowed,
          isSecurityAllowed: item.is_security_allowed,
          isLicenseAllowed: item.is_license_allowed,
          isPolicyAllowed: item.is_policy_allowed,
          isNewlyAdded: true,
        };
      });

      const { bookmarkDataList } = this.state;
      const uniqueData = bookmarkDataList.filter(
        (existingItem) => { return !newData.some((newItem) => { return newItem.id === existingItem.id; }); }
      );

      this.setState({
        bookmarkDataList: destinationIndex != null
          ? this.reorder([...newData, ...uniqueData], 0, destinationIndex)
          : [...newData, ...uniqueData],
        currentCount: uniqueData.length + newData.length,
        selectedRecentList: [],
        selectedIndex: [],
      });
    } catch (err) {
      console.error(err);
    }
  };

  deleteMyRecent() {
    const { deletedId } = this.state;

    this.modalAction = null;
    this.modalBody = null;

    api
      .deleteMyRecentList(deletedId)
      .then(() => {
        this.setState(
          {
            isOpenModal: false,
            deletedId: '',
            recentList: [],
          },
          () => {
            this.getRecentData();
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deleteMyBookmark() {
    const { deletedId } = this.state;

    this.modalAction = null;
    this.modalBody = null;

    api
      .deleteMyBookmark(deletedId)
      .then(() => {
        this.setState(
          {
            isOpenModal: false,
            deletedId: '',
            bookmarkDataList: [],
          },
          () => {
            this.getMyBookmarkData();
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  clearSearch() {
    this.search.value = '';
    this.setState(
      {
        searchKeyword: '',
        bookmarkDataList: [],
      },
      () => {
        this.getMyBookmarkData();
      }
    );
  }

  closeModal() {
    this.modalAction = null;
    this.modalBody = null;

    this.setState({
      isOpenModal: false,
      deletedId: '',
      isOpenError: false,
      selectedIndex: [],
      descriptionWithModal: '',
      isDeleteBookmark: false,
    });
  }

  render() {
    const {
      bookmarkDataList,
      recentList,
      selectedRecentList,
      currentCount,
      errSearch,
      isBookmarkLoading,
      isRecentLoading,
      selectedIndex,
      activeTab,
      uploadedDataList,
      projectDataList,
      activeIndex,
      isOpenModal,
      descriptionWithModal,
      isOpenError,
      isDeleteBookmark,
    } = this.state;

    const { t } = this.props;

    const getListStyle = () => {
      return {
        padding: 8,
        width: '100%',
        zIndex: '1',
      };
    };

    const customHeight = () => {
      if (bookmarkDataList.length > 4) {
        return 445;
      }
      return bookmarkDataList.length * 100;
    };

    const renderElement = (entity, provided, snapshot, index) => {
      return (
        <Ref
          innerRef={provided.innerRef}
          {...provided.draggableProps}
        >
          <BookmarkItem
            item={entity}
            index={index}
            draggableProvided={provided}
            draggableSnapshot={snapshot}
            handleChangeView={this.handleChangeView}
            handleViewPointChange={this.handleViewPointChange}
            handleRemoveBookmark={this.handleRemoveBookmark}
            translate={t}
          />
        </Ref>
      );
    };

    return (
      <DragDropContext
        onDragEnd={this.onDragEnd}
      >
        <div>
          <NavigationBar
            createMyBookmark={this.createMyBookmark}
            selectedIndex={selectedIndex}
            activeTab={activeTab}
            uploadedDataList={uploadedDataList}
            projectDataList={projectDataList}
            getLeftData={this.getLeftData}
            handleTabChange={this.handleTabChange}
            updateTreeIndex={this.updateTreeIndex}
            activeIndex={activeIndex}
            handleToggle={this.handleToggle}
            translate={t}
          />
          <div className="contents_header">
            <div className="contents_header_inner">
              <h3 className="content_title">
                {t('my_page.title.assigned_bookmarks')}
                <em>{currentCount}</em>
              </h3>
            </div>
            <div className="util_wrap">
              <div className="util_item ">
                <div className="search_files_wrap">
                  <img src={searchIcon} alt="" className="icon" />
                  <input
                    type="search_files"
                    className="seach_text"
                    placeholder={t('my_page.title.bookmark_name')}
                    ref={(ref) => {
                      this.search = ref;
                    }}
                    onKeyPress={this.handleSearch}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                  />
                  <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                    x
                  </a>
                  {errSearch && (
                    <Label basic color="red" pointing>
                      {t('contents_header.message.least_two_required_to_search')}
                    </Label>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            {
              isBookmarkLoading ? (
                <div style={{ paddingTop: '16%', height: '445px' }}>
                  <Loader active={isBookmarkLoading} inline="centered" />
                </div>
              ) : (
                <Scrollbars
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                  style={{ height: `${customHeight()}px` }}
                  ref={this.bookmarkListScroll}
                  onScroll={this.handleScroll}
                >
                  <Droppable droppableId="all-bookmarks">
                    {(provided, snapshot) => {
                      return (
                        <div
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                          {...provided.droppableProps}

                        >
                          {bookmarkDataList.map((item, index) => {
                            return (
                              <Draggable
                                key={item.id}
                                draggableId={`bookmark-${item.id}`}
                                index={index}
                              >
                                {(draggableProvided, draggableSnapshot) => {
                                  const child = renderElement(item, draggableProvided, draggableSnapshot, index);
                                  if (draggableSnapshot.isDragging) {
                                    return (
                                      <Portal
                                        open={draggableSnapshot.isDragging}
                                      >
                                        <BookmarkItem
                                          item={item}
                                          index={index}
                                          draggableProvided={draggableProvided}
                                          draggableSnapshot={draggableSnapshot}
                                          handleChangeView={this.handleChangeView}
                                          handleViewPointChange={this.handleViewPointChange}
                                          handleRemoveBookmark={this.handleRemoveBookmark}
                                          translate={t}
                                        />
                                      </Portal>
                                    );
                                  }
                                  return child;
                                }}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      );
                    }}
                  </Droppable>
                </Scrollbars>
              )
            }
            <div className="line" />
          </div>
          <div className="contents_header recent_header">
            <div className="contents_header_inner">
              <h3 className="content_title">
                {t('my_page.title.recent')}
                <em>{recentList.length}</em>
              </h3>
              {selectedRecentList.length !== 0 ? (
                <a
                  className="add_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.handleAddtoBookmark}
                  onKeyUp={this.handleAddtoBookmark}
                >
                  <img src={combineImg} alt="" />
                  &nbsp;
                  {t('modal.button.add')}
                </a>
              ) : (
                <a
                  className="add_button"
                  style={{
                    pointerEvents: 'none',
                    cursor: 'default',
                    opacity: '.45',
                  }}
                >
                  <img src={combineImg} alt="" />
                  &nbsp;
                  {t('modal.button.add')}
                </a>
              )}
            </div>
          </div>
          <div className="content">
            {
              isRecentLoading ? (
                <div style={{ paddingTop: '25px' }}>
                  <Loader active={isRecentLoading} inline="centered" />
                </div>
              ) : (
                <div className="my_bookmarks_item_list">
                  {recentList.length !== 0
                    && recentList.map((item, index) => {
                      return (
                        <BookmarkItemType2
                          item={item}
                          index={index}
                          key={item.id}
                          selectedRecentList={selectedRecentList}
                          handleTableToggle={this.handleTableToggle}
                          handleChangeView={this.handleChangeView}
                          handleRemoveRecentList={this.handleRemoveRecentList}
                          translate={t}
                        />
                      );
                    })}
                </div>
              )
            }
          </div>
          <Modal open={isOpenModal} onClose={this.closeModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  <p className="text">{this.modalBody}</p>
                  <p className="small_text">{descriptionWithModal}</p>
                  <div className="button_wrap">
                    <a className="left_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                      {t('modal.button.cancel')}
                    </a>
                    {
                      isDeleteBookmark ? (
                        <a className="right_button" onClick={this.deleteMyBookmark} onKeyUp={this.deleteMyBookmark}>
                          {t('modal.button.ok')}
                        </a>
                      ) : (
                        <a className="right_button" onClick={this.deleteMyRecent} onKeyUp={this.deleteMyRecent}>
                          {t('modal.button.ok')}
                        </a>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal open={isOpenError} onClose={this.closeModal}>
            <div className="modal_popup_wrap">
              <div className="modal_popup_box">
                <div className="modal_popup">
                  <h2 className="title">{this.modalAction}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      style={{ cursor: 'pointer' }}
                      onClick={this.closeModal}
                      onKeyUp={this.closeModal}
                    >
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </DragDropContext>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(MyBookmark))));
